import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-phone-number-input/style.css';
import API from '../../../utils/API';
import * as modalUtils from '../../../utils/modalUtils';
import useModalInitialization from '../../../hooks/useModalInitialization';

const modalId = 'assignSiteModal';

function AlertUsersModerationModal(props) {
  const { selectedUserIds, setSuccess, setError, dataMap, loadTable } = props;
  
  // Use the modal initialization hook
  const {
    // State
    cms,
    cmses,
    selectedSiteIds,
    cmsDropdownError,
    siteDropdownError,
    
    // Setters
    setCmsDropdownError,
    
    // Computed values
    selectedSitesCount,
    selectedSitesText,
    
    // Handlers
    handleCmsClick,
    closeModal,
    
    // Helper functions
    generateSiteComponents
  } = useModalInitialization({
    modalId,
    selectedUserIds,
    dataMap,
    siteExtractor: modalUtils.extractArrayBasedSiteInfo
  });

  // Modal initialization is now handled by the hook

  // Site tree manipulation functions are now provided by the hook

  const onSave = async () => {
    if (!cms) {
      setCmsDropdownError(<FormattedMessage id="NO_CMS_SELECTED" />);
      return;
    }
    // if (selectedSitesCount === 0) {
    //   setSiteDropdownError(<FormattedMessage id="NO_SITES_SELECTED" />);
    // }

    try {
      console.log('Selected site IDs to send:', selectedSiteIds);
      await API.putAplusUsers(cms, selectedSiteIds, selectedUserIds);
      setSuccess(<FormattedMessage id="ASSIGN_SITE_SUCCESS" />);
      closeModal();
      loadTable(dataMap, false);
    } catch (e) {
      console.error(e);
      setError(<FormattedMessage id="ASSIGN_SITE_FAIL" />);
    }
  };

  // closeModal is provided by the hook

  const siteComponents = generateSiteComponents();
  const hasSites = siteComponents.length > 0;

  useEffect(() => {
    console.log('selectedSiteIds:', selectedSiteIds);
  }, [selectedSiteIds]);

  // selectedSitesCount and selectedSitesText are provided by the hook

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="roleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ overflow: 'visible' }}>
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="ASSIGN_CMS_SITE" defaultMessage="Assign CMS/Site" /></h5>
            <button type="button" id="closeSitesModal" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ overflow: 'visible' }}>
            <div style={{ fontWeight: 'bolder' }}><FormattedMessage id="CMS" /></div>
            <div className="dropdown">
              <button
                style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', color: 'black', border: '1px solid #ced4da' }}
                className="btn btn-secondary form-select"
                type="button"
                id="cmsDropdownMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {cms ? cmses.find(c => c.id === cms)?.name : <FormattedMessage id="SELECT_CMS" />}
              </button>
              <ul
                style={{ textAlign: 'left'}}
                className="dropdown-menu"
                aria-labelledby="cmsDropdownMenu"
              >
                {cmses.map(cmsObj => (
                  <li id="cmsItem" key={cmsObj.id} onClick={() => handleCmsClick(cmsObj.id)}>
                    <span className="dropdown-item">{cmsObj.name}</span>
                  </li>
                ))}
              </ul>
            </div>
            {cmsDropdownError && <div className="text-danger" role="alert">{cmsDropdownError}</div>}
            <div style={{ fontWeight: 'bolder', marginTop: '10px' }}><FormattedMessage id="SITE" /></div>
            <div className="dropdown">
              <button
                style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', color: 'black', border: '1px solid #ced4da', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                className="btn btn-secondary form-select"
                type="button"
                id="siteDropdownMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={!hasSites}
                data-bs-display="static"
              >
                <span style={{ fontWeight: 'bold' }}>{selectedSitesCount} <FormattedMessage id="SELECTED_TEXT" /></span>
                <span style={{ color: '#6c757d', marginLeft: '10px' }}>{selectedSitesText}</span>
              </button>
              <ul
                style={{ textAlign: 'left' }}
                className="dropdown-menu dropdown-menu-start"
                aria-labelledby="siteDropdownMenu"
              >
                {siteComponents}
              </ul>
            </div>
            {siteDropdownError && <div className="text-danger" role="alert">{siteDropdownError}</div>}
            <div className="fw-bold mt-3"><FormattedMessage id="TEACHERS_ASSIGNED_ONE_SITE" defaultMessage="Note: Teachers MUST be assigned to only one site."/></div>
          </div>
          <div className="modal-footer justify-content-between">
            <button id="assignSiteBackBtn" className="btn back-btn" type="button" data-bs-dismiss="modal"><FormattedMessage id="BACK" /></button>
            <button id="assignSiteSaveBtn" className="btn save-btn ms-2" type="submit" onClick={onSave}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlertUsersModerationModal;
